import { Component } from 'react'

class ErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
    this.reset = this.reset.bind(this)
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error }
  }

  componentDidCatch(error, info) {
    console.error(error, info)
  }

  reset() {
    this.setState({ hasError: false })
  }

  render() {
    if (this.state.hasError) {
      const { FallbackComponent, fallbackRender, title } = this.props
      if (fallbackRender) return fallbackRender({ resetErrorBoundary: this.reset, title })
      if (FallbackComponent) return <FallbackComponent resetErrorBoundary={this.reset} />
    }
    return this.props.children
  }
}

export default ErrorBoundary
